import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "max-w-[1040px]" }
const _hoisted_2 = { class: "flex items-center justify-between gap-6" }
const _hoisted_3 = {
  key: 0,
  class: "border-t border-gray-100 pt-5 space-y-5"
}
const _hoisted_4 = { class: "grid gap-5 sm:grid-cols-2" }
const _hoisted_5 = { class: "flex items-center justify-between gap-6" }

import { computed, inject, onMounted, ref } from 'vue'

import InputField from '@/components/neue/InputField'
import NeueLoading from '@/components/neue/NeueLoading'
import NeueToggle from '@/components/neue/NeueToggle'
import SettingsSection from '@/components/neue/SettingsSection.vue'
import api from '@/store/api'
import { mapRelationship } from '@/store/mappers'


export default {
  __name: 'StoreInvoicing',
  props: ['id'],
  setup(__props) {

const bus = inject('bus')
const loading = ref(true)
const props = __props
const store = computed(() => mapRelationship({ type: 'store', id: props.id }))
const invoiceOnly = ref(false)
const invoiceCardFees = ref(false)
const daysUntilDue = ref(30)

onMounted(async () => {
  await api.call('GET', `stores/${props.id}?included=none`)
  loading.value = false
  invoiceOnly.value = store.value.attributes.invoice_only
  invoiceCardFees.value = store.value.attributes.invoice_card_fees
  daysUntilDue.value = store.value.attributes.invoice_days_until_due
})

const saveFlag = attributes => api.call('PUT', `stores/${props.id}?included=none`, { store: attributes })

const setInvoiceOnly = value => saveFlag({ invoice_only: value })

const setInvoiceCardFees = value => saveFlag({ invoice_card_fees: value })

const dirty = () => bus.emit('dirty/store', { from: 'invoicing' })

bus.on('save/store', () => {
  const days = parseInt(daysUntilDue.value, 10)
  if (!Number.isInteger(days) || days < 1) return
  api.call('PUT', `stores/${props.id}?included=none`, {
    store: {
      invoice_days_until_due: days
    }
  })
})

bus.on('discard/store', () => {
  daysUntilDue.value = store.value.attributes.invoice_days_until_due
})

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(_unref(NeueLoading), { loading: loading.value }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(SettingsSection, {
          title: "Invoice only",
          description: "Customers place orders without paying at checkout. A Stripe invoice is sent for each order and the order stays unpaid until the invoice is paid."
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "min-w-0" }, [
                _createElementVNode("p", { class: "text-sm font-semibold text-gray-700 mb-1" }, "Invoice only"),
                _createElementVNode("p", { class: "text-[13px] leading-relaxed text-gray-500" }, "Off means customers pay by card at checkout.")
              ], -1)),
              _createVNode(_unref(NeueToggle), {
                modelValue: invoiceOnly.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((invoiceOnly).value = $event)),
                onChange: setInvoiceOnly
              }, null, 8, ["modelValue"])
            ]),
            (invoiceOnly.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_unref(InputField), {
                      modelValue: daysUntilDue.value,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((daysUntilDue).value = $event)),
                      name: "Days until due",
                      description: "How many days the customer has to pay the invoice.",
                      placeholder: "30",
                      onInput: dirty
                    }, null, 8, ["modelValue"])
                  ]),
                  _cache[4] || (_cache[4] = _createElementVNode("p", { class: "text-sm text-gray-500" }, " Orders on this store need a connected Stripe account. Without one, customers will see an error at checkout. ", -1))
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(SettingsSection, {
          title: "Credit card fees",
          description: "Whether the card processing fee you pass on to customers is added to invoices sent from this store, including invoices for reseller customers."
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _cache[5] || (_cache[5] = _createElementVNode("div", { class: "min-w-0" }, [
                _createElementVNode("p", { class: "text-sm font-semibold text-gray-700 mb-1" }, "Charge credit card fees on invoices"),
                _createElementVNode("p", { class: "text-[13px] leading-relaxed text-gray-500" }, " Off means invoices are sent for the order total and you absorb the processing fee. ")
              ], -1)),
              _createVNode(_unref(NeueToggle), {
                modelValue: invoiceCardFees.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((invoiceCardFees).value = $event)),
                onChange: setInvoiceCardFees
              }, null, 8, ["modelValue"])
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["loading"]))
}
}

}